<template>
    <div class="emojis-explorer">
        <div
            @click="$refs.emojisSearch.focus()"
            class="emojis-search">
            <i class="el-icon-search"></i>
            <input
                ref="emojisSearch"
                :placeholder= "$t('placeholders.emojiSearch')"
                v-model="query"
            />
        </div>
        <div class="emojis-categories">
            <div class="emojis-categories-scroller">
                <div
                    v-for="(emojisCategory, title) in filteredEmojisCategories"
                    :key="title"
                    class="emojis-category">
                    <div class="emojis-category-title">
                        {{ title }}
                    </div>
                    <div class="emojis-category-items">
                        <div
                            class="emojis-category-item"
                            v-for="(emojiItem, index) in emojisCategory"
                            :key="index"
                            @click="$emit('click', emojiItem.emoji)">
                            {{ emojiItem.emoji }}
                        </div>
                    </div>
                </div>
            </div>
            <Loader v-if="isLoading" />
        </div>
    </div>
</template>

<script>
import Loader from './Loader';

const SCROLL_OFFSET = 20;

export default {

    components: {
        Loader
    },

    data() {
        return {
            query: '',
            isLoading: false,
            emojisCategories: {}
        }
    },

    async mounted() {
        this.emojisCategories = this.$root.emojis;
    },

    computed: {
        filteredEmojisCategories() {
            const f = {};
            const { emojisCategories, query } = this;
            const q = query.toLowerCase();

            if (q.length === 0) {
                return emojisCategories;
            }

            for (const key in emojisCategories) {
                if (emojisCategories.hasOwnProperty(key)) {
                    const category = emojisCategories[key];
                    category.forEach(emoji => {
                        const { description, tags, aliases } = emoji;
                        const descriptionTest = description && description.toLowerCase().includes(q.toLowerCase());
                        const tagsTest = tags && tags.some(tag => tag.toLowerCase().includes(q));
                        const aliasesTest = aliases && aliases.some(alias => alias.toLowerCase().includes(q));

                        if (descriptionTest || tagsTest || aliasesTest) {
                            f[key] = (f[key] || []).concat([emoji])
                        }
                    })
                }
            }

            return f;
        }
    },

    methods: {
        
    }
}
</script>

<style scoped lang="scss">

.emojis-explorer {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.emojis-search {
    $spacing: .75rem;
    
    display: flex;
    border-bottom: 1px solid $darkGreyColor;
    padding-bottom: $spacing;

    input {
        border: none;
        outline: none;
        width: 100%;
        display: block;
        font-family: inherit;
        margin-left: .5rem;
        font-size: 13px;
        font-weight: $fontWeight;
    }

    margin-bottom: $spacing;
}

.emojis-categories {
    flex: 1;
    height: 100%;
    overflow-y: auto;
}

.emojis-category {
    margin: 2rem 0;

    &:first-child {
        margin: 0;
    }
}

.emojis-category-title {
    padding-left: 6px;
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 400;
    margin-bottom: .5rem;
}

.emojis-category-item {
    display: inline-block;
    font-size: 28px;
    padding: 5px;
    cursor: pointer;
    user-select: none;
    transition: transform .3s;

    &:hover {
        transform: scale(1.25);
    }
}

.loader {
    margin-top: 1rem;
}

</style>
